import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const fetchJobs = async (params = {}) => {
  const { data } = await api.get("/jobs", { params });
  return data;
};

export const fetchJob = async (id) => {
  const { data } = await api.get(`/jobs/${id}`);
  return data;
};

export const submitApplication = async (formData) => {
  const { data } = await api.post("/applications", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
};

export const submitContact = async (payload) => {
  const { data } = await api.post("/contact", payload);
  return data;
};

export const fetchStats = async () => {
  const { data } = await api.get("/stats");
  return data;
};
